import React from 'react';
import { DrawerProps } from '.';
// to ensure that the same instance of context is used for compound components (e.g. PopoverNext)
// @ts-ignore
import { Drawer } from '../../dist/cjs';

// This object should contain a mock value for each required prop of this component
export const requiredProps: DrawerProps = {
  open: true,
  children: <div>Drawer</div>,
  onClose: () => {},
};

const props: DrawerProps = { ...requiredProps };

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    props,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
